<template>
<!-- 管理员,公司 -->
  <div class="mywork"> 
    <div class="index-header">
      <span class="title">
        <i class="el-icon-caret-right"></i>
        我的工作
      </span>
      <span class="other more" @click="toMore()">
        更多
        <i class="el-icon-d-arrow-right"></i>
      </span>
    </div>
    <div class="container" ref="container">
      <el-tabs
        v-model="activeName"
        type="card"
        :stretch="true"
        tabPosition="left"
        style="height:100%"
      >
        <el-tab-pane label="待办事务" name="first">
          <div class="news">
            <li v-for="(item,index) in workList1" :key="index" @click="toDetail(item)">
              <span class="title">{{item.TaskShowName}}</span>
              <span class="time">{{item.StartTime | formatDate('yyyy-MM-dd')}}</span>
            </li>
          </div>
        </el-tab-pane>
        <el-tab-pane label="完成事务" name="second">
          <div class="news">
            <li v-for="(item,index) in workList2" :key="index" @click="toDetail(item)">
              <span class="title">{{item.TaskShowName}}</span>
              <span class="time">{{item.StartTime | formatDate('yyyy-MM-dd')}}</span>
            </li>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { MyWorkControllerSvr } from '@/service/MyWorkControllerSvr';
import { mapState } from 'vuex';
export default {
  components: {},
  props: {},
  data() {
    return {
      activeName: 'first',
      workList1: [],
      workList2: []
    };
  },
  computed: {
    ...mapState(['token'])
  },
  created() {
    this.MyWorkControllerSvr = new MyWorkControllerSvr();
  },
  mounted() {
    this.getdata(4);
    this.getdata(5);
  },
  methods: {
    //4 代办事务  5完成事务
    getdata(val) {
      const myworkLoading = this.$loading({
        target: document.querySelector('.news')
      });
      this.MyWorkControllerSvr.getMyTaskList(
        this.token,
        null,
        val,
        null,
        null,
        0,
        5
      )
        .then(res => {
          if (val === 4) {
            this.workList1 = res._Items;
          } else if (val === 5) {
            this.workList2 = res._Items;
          }

          myworkLoading.close();
        })
        .catch(() => {
          myworkLoading.close();
        });
    },
    toDetail(item) {
      // if(JSON.parse(item.ActionPara).Url1==='SafeProductionAdd'){
      //   if(item.TaskStatus!=='0'||item.TaskStatus!=='1'){
      //     this.$router.push({
      //       path: '/SafeProductionCensorX',
      //       query: {
      //         workId: item.WorkID,
      //         taskName: item.TaskName,
      //         bisKey: item.MainParaIn.Value,
      //         taskStatus:item.TaskStatus
      //       }
      //     });
      //   }
      // }else if(JSON.parse(item.ActionPara).Url1==='SpecialInspectionAdd'){
      //   if(item.TaskStatus!=='0'||item.TaskStatus!=='1'){
      //     this.$router.push({
      //       path: '/SpecialInspectionCensorX',
      //       query: {
      //         workId: item.WorkID,
      //         taskName: item.TaskName,
      //         bisKey: item.MainParaIn.Value,
      //         taskStatus:item.TaskStatus
      //       }
      //     });
      //   }
      // }else if(JSON.parse(item.ActionPara).Url1 === 'SafeProductionDatil'){
      //   this.$router.push({
      //     path: '/SafeProductionDatil',
      //     query: {
      //       keyId: item.DocCode,
      //       taskName: item.TaskName,
      //       bisKey: item.MainParaIn.Value,
      //       taskStatus: item.TaskStatus
      //     }
      //   });
      // }else 
      if(JSON.parse(item.ActionPara).Url1==='AddReprotFill'){
         this.$router.push({
            path: '/propertyDeclareFill',
            query: {
              workId: item.WorkID,
              taskName: item.TaskName,
              bisKey: item.MainParaIn.Value,
              taskStatus:item.TaskStatus
            }
          });
      }
      else{
        this.$router.push({
          path: JSON.parse(item.ActionPara).Url1,
          query: {
            workId: item.WorkID,
            taskName: item.TaskName,
            bisKey: item.MainParaIn.Value,
            taskStatus:item.TaskStatus
          }
        });
      }
    },
    toMore() {
      this.$router.push({
        path:'/myworkList',
        query:{
          taskStatus:this.activeName === 'first' ? 4 : 5
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import './css/common.scss';
.mywork {
  background: #fff;
  .container {
    height: 210px;
    overflow: hidden;
    .news {
      li {
        padding: 5px 12px;
        display: flex;
        justify-content: space-between;
        height: 35px;
        line-height: 25px;
        font-size: 14px;
        box-sizing: border-box;
        cursor: pointer;
        .title {
          margin-left: 10px;
          position: relative;
          &::after {
            position: absolute;
            left: -10px;
            top: 50%;
            margin-top: -3px;
            content: '';
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background: #0f77f2;
          }
        }
        &:nth-child(2n) {
          background: #f7f8fa;
        }
        &:hover {
          background: #e3f0ff;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.mywork {
  background: #fff;
  .container {
    .el-tabs {
      .el-tabs__header {
        .el-tabs__nav {
          border-top: none;
          border-bottom: none;
        }
        .el-tabs__item {
          width: 210px;
          font-size: 14px;
          text-align: center;
          height: 103px;
          line-height: 103px;
          &.is-active {
            border-bottom: 4px solid #0f77f2 !important;
          }
        }
      }
      .el-tabs__content {
        height: 100%;
        padding: 10px 0;
      }
    }
  }
}
</style>
